/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceCompetitionPrizePool
 */
export interface SurfaceCompetitionPrizePool {
    /**
     * 
     * @type {number}
     * @memberof SurfaceCompetitionPrizePool
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionPrizePool
     */
    currency: string;
}

/**
 * Check if a given object implements the SurfaceCompetitionPrizePool interface.
 */
export function instanceOfSurfaceCompetitionPrizePool(value: object): value is SurfaceCompetitionPrizePool {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function SurfaceCompetitionPrizePoolFromJSON(json: any): SurfaceCompetitionPrizePool {
    return SurfaceCompetitionPrizePoolFromJSONTyped(json, false);
}

export function SurfaceCompetitionPrizePoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceCompetitionPrizePool {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'currency': json['currency'],
    };
}

export function SurfaceCompetitionPrizePoolToJSON(json: any): SurfaceCompetitionPrizePool {
    return SurfaceCompetitionPrizePoolToJSONTyped(json, false);
}

export function SurfaceCompetitionPrizePoolToJSONTyped(value?: SurfaceCompetitionPrizePool | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'currency': value['currency'],
    };
}

